import { Routes, Route, Navigate } from 'react-router-dom'
import { App as AntdApp } from 'antd'
import { useAuthStore } from '@/stores/authStore'
import LoginPage from '@/pages/Login'
import Layout from '@/components/Layout'
import Dashboard from '@/pages/Dashboard'
import Conversations from '@/pages/Conversations'
import Profile from '@/pages/Profile'
import Settings from '@/pages/Settings'
import ProtectedRoute from '@/components/ProtectedRoute'

// 新增页面组件
import LatestSessions from '@/pages/Conversations/LatestSessions'
import ChatManagement from '@/pages/Conversations/ChatManagement'
import ModelUsage from '@/pages/Analytics/ModelUsage'
import TokenBilling from '@/pages/Analytics/TokenBilling'
import CostAnalysis from '@/pages/Analytics/CostAnalysis'
import UserBehavior from '@/pages/Analytics/UserBehavior'
import ProxyStatus from '@/pages/Monitoring/ProxyStatus'
import LogManagement from '@/pages/Monitoring/LogManagement'
import ErrorMonitoring from '@/pages/Monitoring/ErrorMonitoring'
import RealTimeMonitor from '@/pages/Monitoring/RealTimeMonitor'
import ModelPricing from '@/pages/ModelConfig/ModelPricing'
import ModelManagement from '@/pages/ModelConfig/ModelManagement'
import ProxySettings from '@/pages/Settings/ProxySettings'
import TestChart from '@/pages/TestChart'

function AppContent() {
  const { isAuthenticated } = useAuthStore()

  window.logger?.info('App rendered', { isAuthenticated })

  return (
    <div className="App">
      <Routes>
        {/* 公开路由 */}
        <Route path="/login" element={<LoginPage />} />

        {/* 受保护的路由 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* 会话管理路由 */}
          <Route path="conversations" element={<Conversations />} />
          <Route path="conversations/latest" element={<LatestSessions />} />
          <Route path="conversations/chat" element={<ChatManagement />} />

          {/* 数据分析路由 */}
          <Route path="analytics/models" element={<ModelUsage />} />
          <Route path="analytics/billing" element={<TokenBilling />} />
          <Route path="analytics/costs" element={<CostAnalysis />} />
          <Route path="analytics/users" element={<UserBehavior />} />

          {/* 监控路由 */}
          <Route path="monitoring/proxy" element={<ProxyStatus />} />
          <Route path="monitoring/logs" element={<LogManagement />} />
          <Route path="monitoring/errors" element={<ErrorMonitoring />} />
          <Route path="monitoring/realtime" element={<RealTimeMonitor />} />

          {/* 模型配置路由 */}
          <Route path="models/pricing" element={<ModelPricing />} />
          <Route path="models/management" element={<ModelManagement />} />

          {/* 系统设置路由 */}
          <Route path="settings/proxy" element={<ProxySettings />} />

          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="test-chart" element={<TestChart />} />
        </Route>

        {/* 404 重定向 */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <AntdApp>
      <AppContent />
    </AntdApp>
  )
}

export default App
